module.exports = __webpack_public_path__ + "img/box_query_menu_tooltip.959909ea.svg";